// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__gBu1y","loaderContainerPdf":"loader_loaderContainerPdf__SIdZd","loader":"loader_loader__iYS51"};